var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect } from "react";
import styled from "styled-components";
import { Meta } from "app/Meta";
import { Helmet } from "react-helmet-async";
import { config } from "core/utils";
import { mq } from "core/styles/snippets";
export var TvGuide = function (_a) {
    var _b;
    var origin = _a.origin, data = _a.data;
    useEffect(function () {
        // Add class to body when component mounts
        document.body.classList.add('tvguide-page');
        // Remove class when component unmounts
        return function () {
            document.body.classList.remove('tvguide-page');
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Meta, { data: {
                pageTitle: data.title,
                description: (_b = data.metadata.find(function (meta) { return meta.name === "description"; })) === null || _b === void 0 ? void 0 : _b.content,
                imageUrl: config.urls.absoluteUrl(origin, config.meta.defaultImage),
                url: data.canonicalUrl,
                ogType: "website",
            } }),
        React.createElement(Helmet, null,
            data.metadata &&
                data.metadata.map(function (meta) { return (React.createElement("meta", { name: meta.name, content: meta.content, key: meta.name })); }),
            data.js && data.js.map(function (jsUrl) { return React.createElement("script", { src: jsUrl, key: jsUrl }); })),
        React.createElement(Content, { dangerouslySetInnerHTML: { __html: data.html } })));
};
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  margin: 0 auto 2rem;\n  padding: 0 1rem;\n\n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding: 0 2.5rem;\n    margin-bottom: 3rem;\n  }\n\n  ", " {\n    padding: 0 5rem;\n    margin-bottom: 3.5rem;\n  }\n\n  ", " {\n    margin-bottom: 5rem;\n  }\n\n  .tvgm-container {\n    width: 100% !important;\n    max-width: 110rem !important;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  margin: 0 auto 2rem;\n  padding: 0 1rem;\n\n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding: 0 2.5rem;\n    margin-bottom: 3rem;\n  }\n\n  ", " {\n    padding: 0 5rem;\n    margin-bottom: 3.5rem;\n  }\n\n  ", " {\n    margin-bottom: 5rem;\n  }\n\n  .tvgm-container {\n    width: 100% !important;\n    max-width: 110rem !important;\n  }\n"])), mq.minWidth("48rem"), mq.minWidth("64rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var templateObject_1;
